import { Model, Attr, HasOne } from 'spraypaint';
import { Organisation, User } from '@/api';
import ApplicationRecord from '../ApplicationRecord';

export enum OrganisationalEventType {
  'ActionLevelGrid' = 'action_level_grid',
  'RecipeComparisonReport' = 'recipe_comparison_report',
  'ShortRecipeReport' = 'short_recipe_report',
  'LongRecipeReport' = 'long_recipe_report',
  'RecipePublished' = 'recipe_published',
}

@Model()
export default class OrganisationalEvent extends ApplicationRecord {
  static jsonapiType = 'organisational-events';

  static scopeFactory() {
    return OrganisationalEvent.includes([]);
  }

  @Attr() readonly created: string;

  @HasOne() readonly createdBy: User;

  @HasOne() organisation: Organisation;

  @Attr() eventType: OrganisationalEventType;

  @Attr() details: {
    [key: string]: string;
  };
}
